<busy-notice
    [isBusy]="this.isBusy"
    [busyText]="this.busyText"
    headerText="KANSO">
</busy-notice>
